import { cn } from '@/lib/utils'

interface TrendLabelProps {
  title?: string
  total?: string
  trend?: string
  trendClass?: string
  trendCountClass?: string
}

export default function TrendLabel({
  title,
  total,
  trend,
  trendClass,
  trendCountClass,
}: TrendLabelProps) {
  const hasExplicitTrendClass = Boolean(trendClass)
  const isNegativeTrend = trend?.trim().startsWith('-')
  const isPositiveTrend = trend?.trim().startsWith('+')
  const computedTrendClass = hasExplicitTrendClass
    ? trendClass
    : isNegativeTrend
      ? 'text-red-600'
      : isPositiveTrend
        ? 'text-green-600'
        : undefined

  return (
    <div>
      <p className='text-[#A3A3A3] text-sm'>{title}</p>
      <h1
        className={cn(
          'SFProMedium text-[1.3rem] text-[#000000] font-bold',
          trendCountClass,
        )}
      >
        {total ?? '----'}
      </h1>
      <p className={cn('text-[#A3A3A3] text-sm', computedTrendClass)}>
        {trend ?? '----'}
      </p>
      <div></div>
    </div>
  )
}
